import React__default from 'react';
import _s, { css } from 'styled-components';
import { n as noop } from './noop-fc861ff1.js';
import useTheme from './useTheme.js';
import Box from './Box.js';
import Typography from './Typography.js';
import Pressable from './Pressable.js';
import Icon from './Icon.js';
import SwipeableDrawer from './SwipeableDrawer.js';

const styled$1 = typeof _s === "object" && "default" in _s ? _s.default : _s;
const BottomSheetHeader = ({
  title,
  leftItemProps
}) => /*#__PURE__*/React__default.createElement(TitleContainer, null, /*#__PURE__*/React__default.createElement(Box, {
  flex: 1
}, leftItemProps ? /*#__PURE__*/React__default.createElement(Box, {
  paddingLeft: "small"
}, /*#__PURE__*/React__default.createElement(Pressable, {
  onPress: leftItemProps.onPress,
  testID: leftItemProps.testID
}, /*#__PURE__*/React__default.createElement(Icon, {
  color: "primary",
  name: leftItemProps.iconName
}))) : null), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
  variant: "headline-3",
  color: "primary"
}, title)), /*#__PURE__*/React__default.createElement(Box, {
  flex: 1
}));
const TitleContainer = styled$1.div`
  ${({
  theme
}) => css(["width:100%;border-bottom-color:", ";border-bottom-width:", "px;border-bottom-style:solid;justify-content:center;padding-bottom:", "px;padding-top:", "px;display:flex;"], theme.borderColors.primary, theme.borderWidths.base, theme.spacings.xSmall, theme.spacings.xSmall)}
`;

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const BottomSheet = ({
  children,
  onClose,
  open,
  testID,
  title,
  leftItemProps,
  height,
  zIndex,
  contentStyle
}) => {
  const [theme] = useTheme();
  return /*#__PURE__*/React__default.createElement(SwipeableDrawer, {
    disableSwipeToOpen: true,
    anchor: "bottom",
    onClose: onClose,
    onOpen: noop,
    open: open,
    style: {
      zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : theme.zIndices.bottomSheet
    },
    PaperProps: {
      style: {
        height,
        background: theme.backgroundColors.elevated,
        borderTopLeftRadius: theme.borderRadius.large,
        borderTopRightRadius: theme.borderRadius.large
      }
    }
  }, /*#__PURE__*/React__default.createElement(Handle, null), /*#__PURE__*/React__default.createElement(BottomSheetHeader, {
    title: title,
    leftItemProps: leftItemProps
  }), /*#__PURE__*/React__default.createElement(Box, {
    style: contentStyle,
    padding: "small",
    testID: testID
  }, children));
};
const Handle = styled.div`
  ${({
  theme
}) => css(["height:", "px;width:", "px;background-color:", ";align-self:center;margin-top:", "px;"], theme.spacings.xTiny, theme.spacings.xLarge, theme.shapeFills.quinary, theme.spacings.tiny)}
`;

export { BottomSheet as B };
//# sourceMappingURL=bottom-sheet-90fa02f3.js.map
